module.exports = __webpack_public_path__ + "static/media/2.51e26fb2.jpg";